<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6 v-if="user.role.roleName !='SALE_MANAGER'" >
        <div style="display: flex; justify-content: flex-end;">
          <v-menu offset-y>
            <template v-slot:activator="{on,attrs}">
              <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
              >
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="openDialog=true">
                <v-list-tile-content>
                  <v-list-tile-title>IMPORT EXCEL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
        
          <v-menu offset-y>
            <template v-slot:activator="{on, attrs}">
              <v-btn
              color="success"
              :loading="printAllButtonLoading"
              v-bind="attrs"
              v-on="on"
              ><v-icon>cloud_download</v-icon>Export</v-btn>
            </template>

            <v-list>
              <v-list-tile @click="printAllCustomerShop('printCustomerShop')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllCustomerShop()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{ showFilters ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Customer Shop Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="township"
                label="TownShip"
                type="text"
                v-model="queryParams.township"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Customer Shop Code"
                type="text"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="customerShopType"
                label="Choose Trade Type ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.type"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="shopTypeList"
                label="Choose Shop Type ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="name"
                item-value="id"
                menu-props="auto"
                v-model="queryParams.shopTypeId"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="regionList"
                label="Region"
                v-model="queryParams.regionId"
                item-text="name"
                item-value="id"
                @change="changeRegion"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs15 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="customerShopList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
          <template slot="items" slot-scope="props">
              <td>
                <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>
                <v-icon v-if="props.item.status=='ACTIVE'" medium color="green">check_circle</v-icon>
                <v-icon v-else medium color="red">cancel</v-icon>
              </td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.type }}</td>
              <td>{{ props.item.shopTypeDTO.name }}</td>
              <td>{{ props.item.customerDTO.name }}</td>
              <td>{{ props.item.priceModelName }}</td>
              <td>{{ props.item.cityDTO.name }}</td>
              <td>{{ props.item.townshipDTO.name }}</td>
              <td>{{ props.item.locationX }}</td>
              <td>{{ props.item.locationY }}</td>
              <td>{{ props.item.address }}</td>
              <td>{{ props.item.phoneNo }}</td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <div id="printCustomerShop" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Customer Shop Report</p>
      </div>
      <br />
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;
          width: 100%;font-size:11px;border-top:1px solid black"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left">Customer Shop Name</th>
              <th style="text-align:left">Customer Shop Code</th>
              <th style="text-align:left">Trade Type</th>
              <th style="text-align:left">Shop Type</th>
              <th style="text-align:left">Customer Name</th>
              <th style="text-align:left">Price Model</th>
              <th style="text-align:left">City</th>
              <th style="text-align:left">Township</th>
              <th style="text-align:left">LocationX</th>
              <th style="text-align:left">LocationY</th>
              <th style="text-align:left">Address</th>
              <th style="text-align:left">Phone Number</th>
              <th style="text-align:left">Description</th>
              <th style="text-align:left">Updated Date</th>
              <th style="text-align:left">Updated By</th>
              <th style="text-align:left">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allCustomerShopList" :key="index">
              <td style="text-align:left">{{ item.name }}</td>
              <td style="text-align:left">{{ item.code }}</td>
              <td style="text-align:left">{{ item.type }}</td>
              <td style="text-align:left">{{ item.shopTypeDTO.name }}</td>
              <td style="text-align:left">{{ item.customerDTO.name }}</td>
              <td style="text-align:left">{{ item.priceModelName }}</td>
              <td style="text-align:left">{{ item.cityDTO.name }}</td>
              <td style="text-align:left">{{ item.townshipDTO.name }}</td>
              <td style="text-align:left">{{ item.locationX }}</td>
              <td style="text-align:left">{{ item.locationY }}</td>
              <td style="text-align:left">{{ item.address }}</td>
              <td style="text-align:left">{{ item.phoneNo }}</td>
              <td style="text-align:left">{{ item.description }}</td>
              <td style="text-align:left">{{ item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
              <td style="text-align:left">{{ item.updatedBy }}</td>
              <td style="text-align:left">{{ item.status }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- dialog -->
    <customerShopExcel :isOpen="openDialog" v-on:change="dialogClose()"></customerShopExcel>
  </v-container>
</template>

<script>
import { customerShopService } from "../../services/customer-shop-service";
import { shopTypeService } from "../../services/shop-type-service";
import customerShopExcel from "../../components/customer-shop/CustomerShopExcel";
import { regionService } from "../../services/region-service";
import XLSX from "xlsx";

export default {
  name: "CustomerShopList",
  components: { customerShopExcel },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true
      },
      {
        text: "Customer Shop",
        disabled: true
      }
    ],
    statusList: [
      { label: "--- ALL ---", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" }
    ],
    headers: [
      { text: "Action", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Customer Shop Name", align: "left", value: "name" },
      { text: "Customer Shop Code", value: "code" },
      { text: "Trade Type", value: "type" },
      { text: "Shop Type", value: "type" },
      { text: "Customer Name", value: "customer.name" },
      { text: "Price Model", value: "priceModel.name" },
      { text: "City", value: "city.name" },
      { text: "Township", value: "township.name" },
      { text: "LocationX", sortable: false },
      { text: "LocationY", sortable: false },
      { text: "Address", value: "address" },
      { text: "Phone Number", value: "phoneNo" },
      { text: "Description", value: "description" },
      { text: "Updated  Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    queryParams: {
      name: "",
      code: "",
      type: "",
      shopTypeId: "",
      township: "",
      regionId: "",
      status: "",
    },
    customerShopList: [],
    allCustomerShopList: [],
    openDialog : false,
    shopTypeList: [],
    totalRows: 0,
    customerShopType: [
      { label: "----All----", value: "" },
      { label: "WHOLESALE", value: "WHOLESALE" },
      { label: "MODERN_TRADE", value: "MODERN_TRADE" },
      { label: "GENERAL_TRADE", value: "GENERAL_TRADE" }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "name",
      totalItems: 0
    },
    printAllButtonLoading: false,
    regionList: [],
  }),  
  watch: {
    pagination: {
      handler() {
        this.getCustomerShopList();
      },
      deep: true
    }
  },
  created() {
    //for deep linking
    this.queryParams.status = "ACTIVE";
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.type) {
      this.queryParams.type = this.$route.query.type;
    }
    if (this.$route.query.shopTypeId) {
      this.queryParams.shopTypeId = this.$route.query.shopType;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.changeRegion();
    this.getShopTypeList();
    this.getRegionList();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "customer-shops", query: this.queryParams });
      this.getCustomerShopList();
    },
    getCustomerShopList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      customerShopService
        .getCustomerShops(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.customerShopList = res.data.customerShopList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    exportAllCustomerShop() {
      this.printAllButtonLoading = true;
      customerShopService
        .getAllCustomerShop(this.queryParams)
        .then(res => {
          if (res.data) {
            this.allCustomerShopList = res.data.customerShopList;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          setTimeout(() => {
            var worksheet = XLSX.utils.table_to_sheet(
              document.getElementById("printCustomerShop")
            );
            var wscols = [{ wch: 15 }, { wch: 40 }, { wch: 10 }, { wch: 10 }];

            worksheet["!cols"] = wscols;
            var new_workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(new_workbook, worksheet, "SheetJS");
            var currentDate = new Date();
            var dTime =
              currentDate.getFullYear() +
              "" +
              currentDate.getMonth() +
              "" +
              currentDate.getDate() +
              "-" +
              currentDate.getTime();
            var excelFilename = "judo-customershop_export-" + dTime + ".xlsx";
            XLSX.writeFile(new_workbook, excelFilename);

            this.isPrint = false;
            this.exportExcelDialog = false;
          }, 500);
        });
      this.printAllButtonLoading = false;
    },
    printAllCustomerShop(divName) {
      this.printAllButtonLoading = true;
      customerShopService
        .getAllCustomerShop(this.queryParams)
        .then(res => {
          if (res.data) {
            this.allCustomerShopList = res.data.customerShopList;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
        });
      this.printAllButtonLoading = false;
    },
    getShopTypeList() {
      this.queryParams.status = "ACTIVE";
      shopTypeService
        .getShopTypeList(this.queryParams)
        .then(res => {
          if (res.data) {
            this.shopTypeList = res.data.shopTypeList;
            let findAll = {
              id: "",
              name: "--- All ---"
            };
            this.shopTypeList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/customer-shop/new");
    },
    dialogClose() {
      this.openDialog = false;
      this.getCustomerShopList();
    },
    onEdit(customerShop) {
      // go to details page
      this.$router.push("/customer-shop/" + customerShop.id);
    },
    
     getRegionList() {
      regionService
        .getRegionsByStatus("ACTIVE")
        .then(res => {
          this.regionList = res.data;
          let noregion = {
            id: "",
            name: "----No Region----"
          };
          this.regionList.splice(0, 0, JSON.parse(JSON.stringify(noregion)));
        })
        .catch(err => {
          console.log(err);
        });
    },
    changeRegion(){
      if(this.queryParams.regionId){
        this.queryParams.isNoRegion = false;
      } else {
        this.queryParams.isNoRegion = true;
      }
    },
  }
};
</script>

